import React from 'react';

interface SectionTitleProps {
  text: string;
}

export function SectionTitle({ text }: SectionTitleProps) {
  return <p className='mb-1 text-[20px] font-[500] text-ventory-grey-modern-700'>{text}</p>;
}
